import { useWeb3React } from "@web3-react/core";
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import config from '../config.json'
import abi from '../abi.json'
import { useState, useEffect } from "react";

function Mint(){
    const {library, account} = useWeb3React();
    const [count, setCount] = useState(1);
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        const web3 = new Web3(library)
        Web3EthContract.setProvider(web3)
        console.log(library)
    },[library])

    const mint = () => {
        const cost = config.WEI_COST;
        const gasLimit = config.GAS_LIMIT;
        const totalCostWei = String(cost * count);
        const totalGasLimit = String(gasLimit * count);
        const contract = new Web3EthContract(abi, config.CONTRACT_ADDRESS);
        contract.methods
        .mint(count)
        .send({
          gasLimit: String(totalGasLimit),
          to: config.CONTRACT_ADDRESS,
          from: account,
          value: totalCostWei,
        })
        .once("error", (err) => {
          console.log(err);
          setSuccess(false)
          setError(true)
        })
        .then((receipt) => {
          console.log(receipt);
          setError(false)
          setSuccess(true)
        });
    }
    const increment = () => {
        if(count!=15){
            setCount(count+1)
        }
    }

    const decrement = () => {
        if(count!=1){
            setCount(count-1)
        }
    }
    return(
        <div>
            <div className="flex justify-center mt-2">
                <button onClick={decrement} type="button" className="text-white rounded-full bg-purple-700 hover:bg-purple-800 font-medium text-sm px-5 py-2.5 mb-2">-</button> 
                <span className="text-white font-thin mx-5 my-auto">{count}</span>
                <button onClick={increment} type="button" className="text-white rounded-full bg-purple-700 hover:bg-purple-800 font-medium text-sm px-5 py-2.5 mb-2">+</button>
            </div>
            <button onClick={mint} type="button" className="w-full focus:outline-none text-white bg-green-700 hover:bg-green-800 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">Mint</button>
            <div className="flex justify-between">
                <div className="text-white font-thin">Price Per NFT: {config.DISPLAY_COST}</div> <div className="text-white font-thin">Gas: {config.GAS_LIMIT}</div>
            </div>
                {error ? <div className="p-4 mt-2 text-sm text-red-700 bg-red-100 rounded-lg" role="alert">
                                <span className="font-medium">Mint was unsuccessful!</span> <span className="font-semibold underline hover:text-red-800 text-red-900">Try Again Later</span>
                            </div>:null}               
                {success ? <div className="p-4 mt-2 text-sm text-green-700 bg-green-100 rounded-lg" role="alert">
                                <span className="font-medium">Mint was successful!</span> <a href="https://opensea.io" className="font-semibold underline hover:text-green-800 text-green-900">View on OpenSea</a>
                            </div>:null}
        </div>
    )    
}


export default Mint;